import axios from "./axios";

const revenueApi = {
  getRevenueStats: () => axios.get("/admin/revenue/stats"),
};

export default revenueApi;
